// extracted by mini-css-extract-plugin
module.exports = {"w180az57":"w180az57"};